import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetOffer = createAsyncThunk(
  "offerData/GetOffer",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(endPoint.GETOFFER);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetOfferSlice = createSlice({
  name: "OfferData",
  initialState: {
    OfferData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOffer.fulfilled, (state, action) => {
        state.OfferData = action.payload;
      })
      .addCase(GetOffer.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetOfferSlice.reducer;
